export function getParameterByName(name: any, url?: string | null) {
  if (!url) {
    return null;
  }
  var match = RegExp('[?&]' + name + '=([^&]*)').exec(url);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
